import Docxtemplater from 'docxtemplater'
import ImageModule from 'docxtemplater-image-module'
import { saveAs } from 'file-saver';
// import JSZipUtils from './jszip-utils';
import JSZip from 'jszip'
import docx from 'file!./template.docx';
import foodDocx from 'file!./foodsafety.docx';
var loadFile=function(url, callback){
  JSZipUtils.getBinaryContent(url,callback);
}

import dataURItoBlob from './dataURI'

export default (data, name, docxTemplate) => {
  name = name || "output.docx";
  let template = docx;
  if (docxTemplate == 'foodsafety.docx') {
    template = foodDocx;
  }
  loadFile(template, function(err,content){
    if (err) { throw err};
    let doc=new Docxtemplater();
    const opts = {
      centered: true,
      getImage: function(tagValue, tagName) {
      return  dataURItoBlob(tagValue.dataUrl);
      },
      getSize:function(img, tagValue, tagName) {
        return [tagValue.width, tagValue.height];
      },
    };
    const imageModule=new ImageModule(opts);
    doc.attachModule(imageModule);

    const zip = new JSZip(content);
    doc.loadZip(zip)
    doc.setData(data) //set the templateVariables
    doc.render() //apply them (replace all occurences of {first_name} by Hipp, ...)
    let out=doc.getZip().generate({type:"blob"}) //Output the document using Data-URI
    saveAs(out, name)
  })
}



/** WEBPACK FOOTER **
 ** ./src/app/helpers/downloadClipping/index.js
 **/